/* eslint-disable @typescript-eslint/naming-convention */
import { put } from 'redux-saga/effects';
import { DOM } from '@app/utils';
import { track, Events, Categories } from '@app/analytics';
import { addYears } from '@app/datetime';
import type { EffectCreatorParams } from '../types';

interface SetShowWhereAreYouModalPayload {
  showWhereAreYouModal: boolean;
  dismissed: boolean;
  banner: boolean;
}

export function* onSetShowWhereAreYouModal({
  payload: { showWhereAreYouModal, dismissed, banner = false },
}: EffectCreatorParams<SetShowWhereAreYouModalPayload>) {
  const cookieTimes = {
    stockx_dismiss_modal_expiration: addYears(new Date(), 1).toISOString(),
    stockx_dismiss_modal_set: new Date().toISOString(),
  };

  if (!showWhereAreYouModal) {
    DOM.forceSetCookie('stockx_dismiss_modal', true, {
      path: '/',
      maxAge: 3.154e7,
    });

    DOM.forceSetCookie(
      'stockx_dismiss_modal_set',
      cookieTimes.stockx_dismiss_modal_set,
      {
        path: '/',
        maxAge: 3.154e7,
      },
    );

    DOM.forceSetCookie(
      'stockx_dismiss_modal_expiration',
      cookieTimes.stockx_dismiss_modal_expiration,
      {
        path: '/',
        maxAge: 3.154e7,
      },
    );

    if (dismissed) {
      yield put(
        track({
          event: banner
            ? Events.LocationBannerDismissed
            : Events.LocationModalDismissed,
          properties: {
            category: Categories.LocationModal,
          },
        }),
      );
    }

    // todo do we still need this?
    document.body.classList.remove('noscroll');
  }
}
